module.exports = __webpack_public_path__ + "static/media/remedoLogoWhite.d169ac19.png";